let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bt202")).then(() => parcelRequire('8LbPV'));